import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Button, Box } from '@mui/material';
import Controls from '../../../Components/controls/Controls';
import { resetSelector, startResetPassword } from '../../../Store/UsersAccount/userAccount.slice.selector';
import { useNavigate } from 'react-router';

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    userID: '',
    email: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate()
  const resetSelectordata = useSelector(resetSelector)

  const validateEmail = (email) => {
    return /.+@.+\..+/.test(email);
  };

  const validateFields = (fieldValues = formData) => {
    let temp = { ...errors };

    // if ('userID' in fieldValues) {
    //   temp.userID = fieldValues.userID ? '' : 'User ID is required.';
    // }

    if ('email' in fieldValues) {
      temp.email = fieldValues.email
        ? validateEmail(fieldValues.email)
          ? ''
          : 'Email is not valid.'
        : 'Email is required.';
    }

    // if ('oldPassword' in fieldValues) {
    //   temp.oldPassword = fieldValues.oldPassword ? '' : 'Old password is required.';
    // }

    if ('newPassword' in fieldValues) {
      temp.newPassword = fieldValues.newPassword ? '' : 'New password is required.';
    }

    if ('confirmPassword' in fieldValues) {
      temp.confirmPassword = fieldValues.confirmPassword
        ? fieldValues.confirmPassword === formData.newPassword
          ? ''
          : 'Passwords do not match.'
        : 'Confirm password is required.';
    }

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === '');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Mark the field as touched
    setTouched({ ...touched, [name]: true });

    // Validate the field as the user types
    validateFields({ [name]: value });
  };

  const handleReset = () => {
    setFormData({
      // userID: '',
      email: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
    setErrors({});
    setTouched({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateFields()) {
      const resetData = {
        userID: 0,
        email: formData.email,
        oldPassword: formData.oldPassword || "",
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
      };

      console.log(resetData, 'res');
      dispatch(startResetPassword(resetData));
    }
  };

  useEffect(()=>{
    if(resetSelectordata === "Password Reset Successfully")
    navigate("/login")
  },[resetSelectordata])

  return (
    <Box
      sx={{
        maxWidth: 600,
        margin: 'auto',
        padding: 3,
        border: '1px solid #ccc',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        Reset Password
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* User ID and Email */}
          {/* <Grid item xs={12} sm={6}>
            <Typography variant="caption" fontWeight="bold">
              User ID
            </Typography>
            <Controls.Input
              placeholder="User ID"
              name="userID"
              fullWidth
              size="small"
              value={formData.userID}
              onChange={handleChange}
              error={touched.userID && errors.userID}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" fontWeight="bold">
              Email
            </Typography>
            <Controls.Input
              placeholder="Email"
              name="email"
              fullWidth
              size="small"
              value={formData.email}
              onChange={handleChange}
              error={touched.email && errors.email}
            />
          </Grid>

          {/* Password Fields */}
          {/* <Grid item xs={12} sm={6}>
            <Typography variant="caption" fontWeight="bold">
              Old Password
            </Typography>
            <Controls.PasswordInput
              placeholder="Old Password"
              name="oldPassword"
              fullWidth
              size="small"
              value={formData.oldPassword}
              onChange={handleChange}
              // error={touched.oldPassword && errors.oldPassword}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" fontWeight="bold">
              New Password
            </Typography>
            <Controls.PasswordInput
              placeholder="New Password"
              name="newPassword"
              fullWidth
              size="small"
              value={formData.newPassword}
              onChange={handleChange}
              error={touched.newPassword && errors.newPassword}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" fontWeight="bold">
              Confirm Password
            </Typography>
            <Controls.PasswordInput
              placeholder="Confirm Password"
              name="confirmPassword"
              fullWidth
              size="small"
              value={formData.confirmPassword}
              onChange={handleChange}
              error={touched.confirmPassword && errors.confirmPassword}
            />
          </Grid>

          {/* Buttons */}
          <Grid item xs={12} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#f5365c',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#c12745',
                },
                width: '48%',
              }}
              type="submit"
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#f5365c',
                color: '#f5365c',
                '&:hover': {
                  backgroundColor: '#fdd6dc',
                  borderColor: '#c12745',
                },
                width: '48%',
              }}
              onClick={handleReset}
              type="button"
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default ResetPassword;
